import { isDatosProductoValido } from '../../../venta/presentation/components/EnvioNacionalModal/DatosProducto';
import {
  EnvioNacionalForm,
  getEnvioNacionalFormInitial,
} from '../../../venta/presentation/components/EnvioNacionalModal/EnvioNacionalModal.types';

export const isRutaCotizacionValida = (form: EnvioNacionalForm): boolean =>
  Boolean(form.remitente.codigoCm && form.destinatario.codigoCm);

export const isLigeroListoParaCotizar = (form: EnvioNacionalForm, esColombia: boolean): boolean =>
  isRutaCotizacionValida(form) && isDatosProductoValido(form.producto, esColombia, true);

const copiarRuta = <T extends EnvioNacionalForm['remitente']>(base: T, origen: T): T => ({
  ...base,
  codigoPostal: origen.codigoPostal,
  municipio: origen.municipio,
  codigoCm: origen.codigoCm,
  codigoCiudadDane: origen.codigoCiudadDane,
  ciudadId: origen.ciudadId,
  ciudadLabel: origen.ciudadLabel,
});

export const toWizardInitialForm = (form: EnvioNacionalForm, pais: string): EnvioNacionalForm => {
  const vacio = getEnvioNacionalFormInitial(pais);
  return {
    remitente: copiarRuta(vacio.remitente, form.remitente),
    destinatario: copiarRuta(vacio.destinatario, form.destinatario),
    producto: form.producto,
  };
};
